import { getRouteApi } from '@tanstack/react-router'
import styled from 'styled-components'
import { FF, RadioGroup, TextInput } from 'ui/components'
import {
  AnnualReviewQuestionColumn as Column,
  AnnualReviewQuestion as Q,
  AnnualReviewQuestionsSet as Set
} from '~bank-annual-review/components/AnnualReviewQuestion'
import {
  questionnaire1Labels,
  questionnaire3Labels,
  questionnaireDemoLabels
} from '~bank-annual-review/constants/questionnaireLabels'
import { ARQuestionnaireFormSchemaName } from '~bank-annual-review/types/AnnualReviewQuestionnaireForm'
import { AnnualReviewEditMode } from '~bank-annual-review/types/Manage'

import { useAnnualReviewFormContext } from '../../../../context/ManageAnnualReviewContext'

const Questions = styled.div`
  margin-top: 34px;
`

export const LicensingQuestionnaire = (): JSX.Element | null => {
  const loaderData = getRouteApi('/_app/annual-review/edit/$companyId/$id').useLoaderData({
    select: (s) => s.form
  }) as AnnualReviewEditMode['form']

  const { formApi } = useAnnualReviewFormContext()

  let schemaName: ARQuestionnaireFormSchemaName | null = null
  let questionnaireLabels: Record<string, string> = {}
  if (loaderData?.questionnaire1) {
    schemaName = 'questionnaire1'
    questionnaireLabels = questionnaire1Labels
  } else if (loaderData?.questionnaire3) {
    schemaName = 'questionnaire3'
    questionnaireLabels = questionnaire3Labels
  } else if (loaderData?.questionnaireDemo) {
    schemaName = 'questionnaireDemo'
    questionnaireLabels = questionnaireDemoLabels
  }

  if (!schemaName) return null

  return (
    <Questions>
      <Set>
        <Column>
          <Q
            label={questionnaireLabels.licensingLocChanges}
            children={
              <formApi.Field
                name={`${schemaName}.licensingLocChanges` as any}
                children={(field) => (
                  <FF
                    field={field}
                    input={(inputProps) => (
                      <RadioGroup
                        data={[
                          {
                            label: 'Yes',
                            value: 'Yes'
                          },
                          {
                            label: 'No',
                            value: 'No'
                          }
                        ]}
                        {...inputProps}
                      />
                    )}
                  />
                )}
              />
            }
          />
        </Column>
        <Column>
          <formApi.Subscribe
            children={({ values }) => (
              <>
                {values[schemaName as string]?.licensingLocChanges === 'Yes' && (
                  <Q
                    label={questionnaireLabels.licensingLocChangesMmcc}
                    children={
                      <formApi.Field
                        name={`${schemaName}.licensingLocChangesMmcc` as any}
                        children={(field) => (
                          <FF
                            field={field}
                            input={(inputProps) => (
                              <RadioGroup
                                data={[
                                  {
                                    label: 'Yes',
                                    value: 'Yes'
                                  },
                                  {
                                    label: 'No',
                                    value: 'No'
                                  }
                                ]}
                                {...inputProps}
                              />
                            )}
                          />
                        )}
                      />
                    }
                  />
                )}
              </>
            )}
          />
        </Column>
      </Set>
      <Set>
        <Column>
          <Q
            label={questionnaireLabels.licensingNameChanges}
            children={
              <formApi.Field
                name={`${schemaName}.licensingNameChanges` as any}
                children={(field) => (
                  <FF
                    field={field}
                    input={(inputProps) => (
                      <RadioGroup
                        data={[
                          {
                            label: 'Yes',
                            value: 'Yes'
                          },
                          {
                            label: 'No',
                            value: 'No'
                          }
                        ]}
                        {...inputProps}
                      />
                    )}
                  />
                )}
              />
            }
          />
        </Column>
        <Column>
          <formApi.Subscribe
            children={({ values }) => (
              <>
                {values[schemaName as string]?.licensingNameChanges === 'Yes' && (
                  <Q
                    label={questionnaireLabels.licensingNameChangesMmcc}
                    children={
                      <formApi.Field
                        name={`${schemaName}.licensingNameChangesMmcc` as any}
                        children={(field) => (
                          <FF
                            field={field}
                            input={(inputProps) => (
                              <RadioGroup
                                data={[
                                  {
                                    label: 'Yes',
                                    value: 'Yes'
                                  },
                                  {
                                    label: 'No',
                                    value: 'No'
                                  }
                                ]}
                                {...inputProps}
                              />
                            )}
                          />
                        )}
                      />
                    }
                  />
                )}
              </>
            )}
          />
        </Column>
      </Set>
      <Set>
        <Column>
          <Q
            label={questionnaireLabels.licensingNamePrior}
            children={
              <formApi.Field
                name={`${schemaName}.licensingNamePrior` as any}
                children={(field) => <FF field={field} input={(inputProps) => <TextInput {...inputProps} />} />}
              />
            }
          />
        </Column>
      </Set>
    </Questions>
  )
}
